// extracted by mini-css-extract-plugin
export var container = "_r7-0";
export var dotAnimation = "_r7-2";
export var dotsLoading = "_r7-1";